import { apiSlice } from "../Api/ApiSlice";

export const taskApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getTask: builder.query({
      query: () => "/tasks",
    }),

    // add task
    addTask: builder.mutation({
      query: (data) => ({
        url: `/tasks`,
        method: "POST",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        try {
          const task = await queryFulfilled;
          if (task?.data) {
            dispatch(
              apiSlice.util.updateQueryData("getTask", undefined, (draft) => {
                // console.log(JSON.parse(JSON.stringify(draft)));
                draft.push(task.data);
              })
            );
          }
        } catch (error) {}
      },
    }),

    // edit task
    updateStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        
          const isStatusUpdate = dispatch(
            apiSlice.util.updateQueryData("getTask", undefined, (draft) => {
              // console.log(JSON.parse(JSON.stringify(draft)));
              const draftTask = draft.find((task) => task.id == arg.id);
              draftTask.status = arg?.data?.status;
            })
          );

          try {
            await queryFulfilled;
          } catch (error) {
            isStatusUpdate.undo();
          }
      },
    }),

    // edit task
    editTask: builder.mutation({
      query: ({ id, data }) => ({
        url: `/tasks/${id}`,
        method: "PATCH",
        body: data,
      }),
      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const updatedTask = await queryFulfilled;

        if (updatedTask?.data?.id) {
          dispatch(
            apiSlice.util.updateQueryData("getTask", undefined, (draft) => {
              // console.log(JSON.parse(JSON.stringify(draft)));
              const draftTask = draft.find((task) => task.id == arg.id);
              draftTask.taskName = updatedTask?.data?.taskName;
              draftTask.teamMember = updatedTask?.data?.teamMember;
              draftTask.project = updatedTask?.data?.project;
              draftTask.deadline = updatedTask?.data?.deadline;
              draftTask.status = updatedTask?.data?.status;
            })
          );
        }
      },
    }),

    // delete Task

    deleteTask: builder.mutation({
      query: ({ id }) => ({
        url: `/tasks/${id}`,
        method: "DELETE",
      }),

      async onQueryStarted(arg, { queryFulfilled, dispatch }) {
        const updateResult = dispatch(
          apiSlice.util.updateQueryData("getTask", undefined, (draft) => {
            return (draft = draft.filter((task) => task.id != arg.id));
          })
        );
        try {
          await queryFulfilled;
        } catch (error) {
          updateResult.undo();
        }
      },
    }),
  }),
});

export const {
  useGetTaskQuery,
  useEditTaskMutation,
  useDeleteTaskMutation,
  useAddTaskMutation,
  useUpdateStatusMutation,
} = taskApi;
